module.exports = __webpack_public_path__ + "img/tutorial_query-patient.fb8855f4.png";